import React, { useEffect, useState } from "react";
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Button,
  Modal,
  Box,
  Stack,
  Typography,
} from "@mui/material";
import { Pie } from "react-chartjs-2";
import PieGraph from "./PieGraph";
import DynamicTable from "./DynamicTable";
const API_URL = process.env.REACT_APP_DOMAIN_API_URL;
const structureData = (rawData) => {
  const labels = [];
  const values = [];
  rawData.forEach((element) => {
    labels.push(element.Category);
    values.push(element.TodayCount);
  });
  return { labels, values };
};
const PieChartModal = ({ open, onClose, data }) => {
  const chartData = {
    labels: ["Red", "Blue", "Yellow"],
    datasets: [
      {
        data: [300, 50, 100],
        backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56"],
        hoverBackgroundColor: ["#FF6384", "#36A2EB", "#FFCE56"],
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <Box
        sx={{
          width: 400,
          height: 400,
          bgcolor: "background.paper",
          border: "2px solid #000",
          boxShadow: 24,
          p: 4,
        }}
      >
        <Typography id="modal-title" variant="h6" component="h2">
          Pie Chart
        </Typography>
        <Pie data={chartData} options={options} />
      </Box>
    </Modal>
  );
};

const ScrollableTable = ({ data }) => {
  const [open, setOpen] = useState(false);
  const [gData, setGData] = useState([]);
  const [data3, setData3] = useState([]);
  const [data2, setData2] = useState({ labels: [], values: [] });
  const [selectedData, setSelectedData] = useState(null);

  const getInitData = async (UnitCode) => {
    const graphData = await fetch(
      `${API_URL}/facility/AnalyzeScanTimesByUnit/${UnitCode}`
    ).then((res) => res.json());
    const data3 = await fetch(
      `${API_URL}/attendance/FULL_AnalyzeScanTimesByUnit/${UnitCode}`
    ).then((res) => res.json());
    if (graphData.success) {
      setGData(graphData.data);
      setData3(data3.data);
    } else {
      alert("Error in getting graph data");
    }
    const structuredData = structureData(graphData.data);
    setData2(structuredData);
  };
  const handleOpen = (data) => {
    setSelectedData(data);
    setOpen(true);
    getInitData(data.UnitCode);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <TableContainer component={Paper} sx={{ maxHeight: 450 }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell style={{ fontWeight: "bold", color: "blue" }}>
                Unit Code
              </TableCell>
              <TableCell style={{ fontWeight: "bold", color: "blue" }}>
                Unit Name
              </TableCell>
              <TableCell style={{ fontWeight: "bold", color: "blue" }}>
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, index) => (
              <TableRow key={index}>
                <TableCell>{row.UnitCode}</TableCell>
                <TableCell>{row.UnitName}</TableCell>
                {/* <TableCell>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleOpen(row)}
                  >
                    Detail
                  </Button> 
                </TableCell>*/}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default ScrollableTable;
